import { render } from "./CardRowData.vue?vue&type=template&id=4fd8707e&ts=true"
import script from "./CardRowData.vue?vue&type=script&lang=ts"
export * from "./CardRowData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__